<template>
    <div class="dropdown" :class="{ 'show': isOpen }">
      <button
      style="border: none; background-color: #fff;  font-size:14px; font-weight: 100; color: #000;"
        class="dropdown-toggle"
        type="button"
        @click="toggleDropdown"
      >
        {{ title }}
      </button>
      <div class="dropdown-menu" :class="{ 'show': isOpen }">
        <slot></slot>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: 'DropDown',
    props: {
      title: {
        type: String,
        required: true
      },
      isOpen: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      toggleDropdown() {
        this.$emit('change', !this.isOpen);
      }
    }
  };
  </script>
  
  <style scoped>
  .dropdown-menu {
    display: block;
    position: absolute;
  }
  .dropdown.show .dropdown-menu {
    display: block;
  }
  </style>
  